<template>
  <div class="root-box">
    <el-table :data="list" :default-expand-all="false" :max-height="tableHeight" :show-header="false" class="no-hover"
      ref="table" stripe>
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="table-expand">
            <el-table :data="props.row.orderList" :show-header="false" class="no-hover">
              <el-table-column width="50">
                <template slot-scope="scope">
                  <span class="order-index">{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="showTime" width="120"></el-table-column>
              <el-table-column prop="orderSource" width="80">
                <template slot-scope="scope">
                  <div v-order-source="scope.row.orderSource"></div>
                </template>
              </el-table-column>
              <el-table-column prop="number" width="60">
                <template slot-scope="scope">{{ scope.row | orderTypeTransfer }}</template>
              </el-table-column>
              <el-table-column prop="price" width="100">
                <template slot-scope="scope">{{ scope.row.price | moneyFormat }}元</template>
              </el-table-column>
              <el-table-column prop="telephone" width="130">
                <template slot-scope="scope">
                  <tel-cell :order="scope.row" />
                </template>
              </el-table-column>
              <el-table-column prop="departure" label="起点"></el-table-column>
              <el-table-column prop="destination" label="终点"></el-table-column>
              <el-table-column prop="orderStatus" width="100">
                <template slot-scope="scope">
                  <span class="red" v-if="scope.row.orderStatus === 'NOT_CONFIRMED'">未确认</span>
                  <span class="red" v-else-if="scope.row.orderStatus === 'WAITING'">等待接单</span>
                  <span class="red" v-else-if="scope.row.orderStatus === 'CANCEL'">已取消</span>
                </template>
              </el-table-column>
              <el-table-column width="100" prop="createTime"></el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="司机编号" width="140">
        <template slot-scope="scope">
          <span class="route-info pointer" @click="toggleRow(scope.row)">{{ scope.row.driverNo }}</span>
          <span v-if="scope.row.changedAfterSolver">（T2）</span>
        </template>
      </el-table-column>
      <el-table-column label="行程信息">
        <template slot-scope="scope">
          <div class="route-info pointer" @click="toggleRow(scope.row)">
            <span>余座</span>
            <span class="red">{{ scope.row.leftSeats }}</span>
            <span>{{ scope.row.date }} / {{ scope.row.showTime }}</span>
            <span>{{ scope.row.pathId | pathNameTransfer }}</span>
            <span v-if="scope.row.seats !== 3 && !scope.row.locked && !scope.row.actualTrip" class="muted">
              {{ scope.row.seats }}座
            </span>
            <span v-if="scope.row.repositionTrip" class="route-tag-empty">（调位）</span>
            <span v-else-if="scope.row.actualTrip" class="route-tag-actual">（已有行程）</span>
            <span v-else class="route-tag-planned">（规划行程）</span>
            <span v-if="scope.row.usedSeats !== scope.row.assignedSeats">规划/指派：{{ scope.row.usedSeats }} / {{
              scope.row.assignedSeats }}
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <span class="pagination-sum">共{{ list.length }}个行程， {{ totalPerson }}人</span>
    </div>
  </div>
</template>

<script>
import TelCell from "@/components/TelCell";

export default {
  components: { TelCell },
  props: {
    trips: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: Number,
      default: 480
    }
  },
  computed: {
    list() {
      return (this.trips || []).map((trip) => {
        return {
          ...trip,
          orderList: trip.orderList || []
        };
      });
    },
    totalPerson() {
      return (this.trips || []).reduce((sum, trip) => sum + (trip.assignedSeats || 0), 0);
    }
  },
  methods: {
    toggleRow(row) {
      this.$refs.table.toggleRowExpansion(row);
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  padding-top: 4px;
  line-height: 18px;
  height: 30px;
}

.table-expand {
  padding: 0 0 0 48px;
}

.order-index {
  display: inline-block;
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  font-size: 12px;
}

.route-info {
  font-size: 14px;

  span {
    margin-right: 10px;
  }
}

.pointer {
  cursor: pointer;
}

.red {
  color: #f56c6c;
}

.muted {
  color: #909399;
  font-size: 12px;
}

.route-tag-planned {
  color: #67c23a;
  font-size: 12px;
}

.route-tag-actual {
  color: #409eff;
  font-size: 12px;
}

.route-tag-empty {
  color: #e6a23c;
  font-size: 12px;
}

.pagination-sum {
  color: #f56c6c;
  font-size: 12px;
  display: inline-block;
}
</style>
